interface Props {
  html: string;
}

const RichTextFieldReadOnly = ({ html }: Props) => (
  <div
    className="border-input focus-visible:border-ring focus-visible:ring-ring/50 dark:bg-input/30 rich-text-editor field-sizing-content max-h-52 min-h-16 w-full overflow-y-auto rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
    // eslint-disable-next-line react-dom/no-dangerously-set-innerhtml
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

export default RichTextFieldReadOnly;
